import React from 'react';

const Quote = () => (
  <div className="container qoute d-flex justify-content-center align-items-center fs-4">
    <q>
      Mathematics is not about numbers, equations, computations
      <br />
      or algotithms: it is about understanding. --Wiliam Paul Thurston
    </q>
  </div>
);
export default Quote;
